import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: undefined, // optional
    ten_tour: undefined, // required Tên tour
    mo_ta: null, // optional Mô tả tour
    chi_tiet: null, // optional Chi tiết tour
    duoc_duyet_id: undefined,
    duyet: // optional
    {
        duoc_duyet: null, // optional Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
        thoi_diem_duoc_duyet: null, // optional Cho biết thời điểm dịch vụ đã được duyệt
        nguoi_duyet_id: null, // optional Mã người duyệt
    },
    thong_tin_chung: // optional Thông tin chung
    {
        kinh_do: undefined, // optional Kinh độ
        vi_do: undefined, // optional Vĩ độ
        url_traveloka: undefined, // optional Đường dẫn bên Traveloka
        url_ivivu: undefined, // optional Đường dẫn bên Ivivu
        url_agoda: undefined, // optional Đường dẫn bên Agoda
        url_vntrip: undefined, // optional Đường dẫn bên Vntrip
        url_chudu24: undefined, // optional Đường dẫn bên chudu24
        link_dich_vu: Array(),
        link_mang_xa_hoi: [
          {
            name: 'Facebook',
            link: undefined
          },
          {
            name: 'Zalo',
            link: undefined
          },
          {
            name: 'Youtube',
            link: undefined
          },
          {
            name: 'Google',
            link: undefined
          },
          {
            name: 'Twitter',
            link: undefined
          }
        ],
    },
    hanh_trinh: // optional Hành trình tour
    {
        thoi_gian_bat_dau: undefined, // optional Thời gian bắt đầu
        thoi_gian_ket_thuc: undefined, // optional Thời gian kết thúc
        dia_diem_bat_dau: undefined, // optional Địa điểm bắt đầu
        dia_diem_ket_thuc: undefined, // optional Địa điểm kết thúc
    },
    cong_ty_lu_hanh_id: undefined, // optional id của công ty lữ hành
    nguoi_tao_id: undefined, // optional Mã người tạo
    mediaId: null, // required id media
    thoi_diem_tao: undefined, // optional Thời điểm tạo,
    ngon_ngu: undefined, // required Ngôn ngữ hiển thị. vi - Việt Nam, en - English
    visible: undefined, // optional Cho biết có muốn hiển thị không
    ready: undefined, // optional Cho biết đã sẵn sàng chờ duyệt chưa
    ly_do_tu_choi: undefined, // optional Lý do từ chối,
    cong_ty_lu_hanh: {
        ten: { //required // Tên sở trường
            vi: null, //string, required // Tên tiếng Việt
            en: null, //string, optional // Tên tiếng Anh
        },
        email: null, //string, optional // Email
        dien_thoai: null, //string, optional // Số điện thoại
        website: null, //string, optional // Website
        dia_chi: { //optional // Địa chỉ
            dia_chi: null, //string, //required // Địa chỉ đầy đủ
        },
    },
    uu_dai: undefined, // optional Giá trị ưu đãi
    loai_hinh_uu_dai: undefined,
    gia_tri_uu_dai: undefined,
}

model.validForm = {
    ten_tour: [ValidService.required],
    thong_tin_chung: {
        url_traveloka: [ValidService.checkLink], // optional Đường dẫn bên Traveloka
        url_ivivu: [ValidService.checkLink], // optional Đường dẫn bên Ivivu
        url_agoda: [ValidService.checkLink], // optional Đường dẫn bên Agoda
        url_vntrip: [ValidService.checkLink], // optional Đường dẫn bên Vntrip
        url_chudu24: [ValidService.checkLink], // optional Đường dẫn bên chudu24
        link_mang_xa_hoi: [
          {
            name: [],
            link: [ValidService.checkLink]
          },
          {
            name: [],
            link: [ValidService.checkLink]
          },
          {
            name: [],
            link: [ValidService.checkLink]
          },
          {
            name: [],
            link: [ValidService.checkLink]
          },
          {
            name: [],
            link: [ValidService.checkLink]
          }
        ]
    },
    hanh_trinh: {
        // thoi_gian_bat_dau: [ValidService.required],
        // thoi_gian_ket_thuc: [ValidService.required],
        dia_diem_bat_dau: [ValidService.required],
        dia_diem_ket_thuc: [ValidService.required]
    },
    mediaId: [ValidService.required],
    mo_ta: [ValidService.required],
    chi_tiet: [ValidService.required],
    ngon_ngu: [ValidService.required],
    visible: [ValidService.required],
    gia_tri_uu_dai: []
}

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            ten_tour: "",
            'thong_tin_chung.ten_cong_ty': "",
            'duyet.duoc_duyet': '',
            // ready: true,
        },
        valid: {
            ten_tour: [],
            'thong_tin_chung.ten_cong_ty': [],
            'duyet.duoc_duyet': [],
        },
        operator: {
            ten_tour: ":regex_i:", //:regex:, $vn_text=Viêt nam
            'thong_tin_chung.ten_cong_ty': ":regex_i:",
            'duyet.duoc_duyet': '',
        }
    }
};

export default model;
